export const ProductType = {
  Baggage: 'Baggage',
  CheckIn: 'Check-in',
  TicketRefund: 'Ticket Refund',
  CommissionRefund: 'Commission Refund',
  Upgrade: 'Upgrade',
  Other: 'Other',
  Voucher: 'Voucher',
  Seats: 'Seats',
  //
  ExtraGP: 'Extra GP',
  Insurance: 'Insurance',
  Miles: 'Miles',
  Ticket: 'Ticket',
  Tips: 'Tips',
  UpgradeTicket: 'Upgrade Ticket',
}

export const ProductSellType = {
  Published: 'public',
  Private: 'private',
  CK: 'inhouse',
  Award: 'award'
}

export const TravelCareType = {
  Decline: 'declineProtection',
  Apply: 'applyProtection'
}
